(() => {

    const Main = {

        init() {
            Main.events();
            Main.sliders();
        },

        events() {
            if (document.body.classList.contains('page-home')) {
                const header = document.querySelector('.header');

                const removeHeaderActive = () => {
                    header?.classList.remove('is-active');
                    window.removeEventListener('scroll', removeHeaderActive);
                    document.removeEventListener('click', removeHeaderActive);
                };

                window.addEventListener('scroll', removeHeaderActive);
                document.addEventListener('click', removeHeaderActive);
            }
        },

        sliders() {
            document.querySelectorAll('.module-projects .project-slider').forEach(element => {
                new Splide(element, {
                    pagination: false,
                    arrows: false
                }).mount();
            });

            document.querySelectorAll('.module-project .project-slider').forEach(element => {
                let lastScrollY = 0;

                const splide = new Splide(element, {
                    type: 'loop',
                    pagination: false,
                    arrows: false,
                    // speed: 0
                }).mount();

                const track = element.querySelector('.splide__track');
                // const totalSlides = splide.length;

                const navPrev = document.createElement('div');
                const navNext = document.createElement('div');
                navPrev.className = 'slider-nav slider-nav--prev';
                navNext.className = 'slider-nav slider-nav--next';
                track.appendChild(navPrev);
                track.appendChild(navNext);

                // const updateNavState = (index) => {
                //     navPrev.classList.toggle('is-disabled', index === 0);
                //     navNext.classList.toggle('is-disabled', index === totalSlides - 1);
                // };

                // updateNavState(0);

                // splide.on('moved', (newIndex) => {
                //     updateNavState(newIndex);
                // });

                navPrev.addEventListener('click', () => splide.go('<'));
                navNext.addEventListener('click', () => splide.go('>'));

                document.querySelectorAll('.module-project .project-content figure[data-index]').forEach(figure => {
                    figure.addEventListener('click', () => {
                        const index = Number(figure.dataset.index);

                        lastScrollY = window.scrollY;

                        document.querySelector('.project-slider')?.classList.remove('is-hidden');
                        document.querySelector('.project-content')?.classList.add('is-hidden');
                        document.querySelector('.footer')?.classList.add('is-hidden');

                        splide.go(index);
                        element.closest('.module-project')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    });
                });

                element.querySelector('.button-close')?.addEventListener('click', () => {
                    document.querySelector('.project-slider')?.classList.add('is-hidden');
                    document.querySelector('.project-content')?.classList.remove('is-hidden');
                    document.querySelector('.footer')?.classList.remove('is-hidden');
                    window.scrollTo({ top: lastScrollY });
                });
            });
        }
    };

    Main.init();
})();
